import {Component, Input, OnInit} from '@angular/core';
import {ApexOptions} from "ng-apexcharts";

@Component({
    selector: 'app-app-funding-need-pie-chart',
    templateUrl: './app-funding-need-pie-chart.component.html',
    styleUrls: ['./app-funding-need-pie-chart.component.scss']
})
export class AppFundingNeedPieChartComponent implements OnInit {
    private _fundingNeedPieData: any;
    get fundingNeedPieData() {
        return this._fundingNeedPieData;
    }

    fundingNeedPieChart: ApexOptions;

    @Input() set fundingNeedPieData(val: any) {
        this._fundingNeedPieData = val;
        if (val) {
            this.fundingNeedPieChart = {
                chart: {
                    toolbar: {
                        show: true
                    },
                    animations: {
                        speed: 400,
                        animateGradually: {
                            enabled: false
                        }
                    },
                    fontFamily: 'inherit',
                    foreColor: 'inherit',
                    height: '100%',
                    type: 'pie',
                    sparkline: {
                        enabled: true
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '13px',
                        // fontWeight: 'bold',
                    },
                    dropShadow: {enabled: false}
                },
                colors: ['#C3C5DB', '#8e99d0', '#6c77a4', '#586288',
                    '#444e6b'],
                labels: this._fundingNeedPieData.labels,
                plotOptions: {
                    pie: {
                        customScale: 0.9,
                        expandOnClick: false,
                        donut: {
                            size: '70%'
                        },
                        dataLabels: {
                            offset: -20
                        }
                    }
                },
                series: this._fundingNeedPieData.series.map(p => p.percentageValue),
                states: {
                    hover: {
                        filter: {
                            type: 'none'
                        }
                    },
                    active: {
                        filter: {
                            type: 'none'
                        }
                    }
                },
                tooltip: {
                    enabled: true,
                    fillSeriesColor: false,
                    theme: 'dark',
                    custom: ({
                                 seriesIndex,
                                 w
                             }): string => `<div class="flex items-center h-8 min-h-8 max-h-8 px-3">
                                                    <div class="w-3 h-3 rounded-full" style="background-color: ${w.config.colors[seriesIndex]};"></div>
                                                    <div class="ml-2 text-md leading-none">${w.config.labels[seriesIndex]}:</div>
                                                    <div class="ml-2 text-md font-bold leading-none">${w.config.series[seriesIndex]}%</div>
                                                </div>`
                }
            };
        }
    }


    constructor() {
    }

    ngOnInit(): void {
    }

}
